export const translations = {
  de: {
    "nav.services": "Leistungen",
    "nav.starlink": "Starlink",
    "nav.why": "Warum wir",
    "nav.process": "Ablauf",
    "nav.blog": "Magazin",
    "nav.contact": "Kontakt",
    "nav.cta": "Beratung anfragen",

    "hero.eyebrow": "Premium Tech Concierge · Mallorca",
    "hero.title": "Digitale & technische Lösungen für Deutsche auf Mallorca",
    "hero.subtitle":
      "Starlink Internet, Premium WLAN, Smart Home, Webseiten, KI-Automationen & technischer Support – alles aus einer Hand.",
    "hero.cta1": "Kostenlos beraten lassen",
    "hero.cta2": "WhatsApp Kontakt",
    "hero.scroll": "Mehr entdecken",
    "hero.trust1": "Deutsche Betreuung",
    "hero.trust2": "Starlink zertifiziert",
    "hero.trust3": "Mesh Spezialist",

    "trust.title": "Vertrauen durch deutsche Präzision auf der Insel",
    "trust.b1": "Deutsche Betreuung",
    "trust.b2": "Vor-Ort-Service Mallorca",
    "trust.b3": "Premium Support",
    "trust.b4": "Starlink Spezialist",
    "trust.kpi1.value": "<24h",
    "trust.kpi1.label": "Reaktionszeit",
    "trust.kpi2.value": "400 Mbit/s",
    "trust.kpi2.label": "Starlink Speed",
    "trust.kpi3.value": "100%",
    "trust.kpi3.label": "Deutschsprachig",

    "services.eyebrow": "Leistungen",
    "services.title": "Eine Adresse für alles, was Technik braucht",
    "services.subtitle":
      "Vom ersten WLAN-Stick bis zur kompletten Smart-Villa – wir planen, installieren und betreuen.",
    "services.starlink.title": "Starlink Internet Mallorca",
    "services.starlink.desc":
      "High-Speed Internet bis 400 Mbit/s für Villen, Fincas und entlegene Standorte. Schnelle Installation, niedrige Latenz, ideal für Remote-Work & Streaming.",
    "services.wifi.title": "Premium WLAN & Mesh",
    "services.wifi.desc":
      "Stabiles WLAN in jedem Winkel Ihrer Villa. Mesh-Systeme, Business-WLAN und Optimierung bestehender Netzwerke.",
    "services.smart.title": "Smart Home & Sicherheit",
    "services.smart.desc":
      "Kameras, smarte Schlösser, Alarmsysteme und Fernüberwachung. Steuern Sie Ihre Villa vom Smartphone aus.",
    "services.digital.title": "Digitale Services",
    "services.digital.desc":
      "Webseiten, Buchungssysteme, SEO, Google Maps Optimierung, KI-Chatbots und Automationen.",
    "services.creator.title": "Creator & Streaming Setups",
    "services.creator.desc":
      "IRL Streaming, Mobile Setups, Starlink für Creator, Encoder, Audio- & Video-Optimierung.",
    "services.support.title": "Tech Support & Concierge",
    "services.support.desc":
      "Deutschsprachiger Support, schnelle Hilfe per WhatsApp, Remote- und Vor-Ort-Service auf Mallorca.",

    "starlink.eyebrow": "Starlink Spezialist",
    "starlink.title": "Starlink Internet auf Mallorca",
    "starlink.p1":
      "Viele Orte auf Mallorca leiden noch immer unter schlechter Internet-Infrastruktur. Wir haben das selbst erlebt – und nach einer Lösung gesucht, die wirklich funktioniert.",
    "starlink.p2":
      "Mit Starlink bringen wir stabile, schnelle Verbindungen in Fincas, Villen und entlegene Standorte. Wir übernehmen Beratung, Installation, Konfiguration und langfristige Betreuung.",
    "starlink.b1": "Internet auch in entlegenen Gebieten",
    "starlink.b2": "Bis zu 400 Mbit/s Download",
    "starlink.b3": "Niedrige Latenz für Remote-Work",
    "starlink.b4": "Streaming-fähige Verbindung",
    "starlink.b5": "Schnelle Installation",
    "starlink.cta": "Starlink Beratung anfragen",
    "starlink.step1": "Standort-Analyse",
    "starlink.step2": "Hardware-Lieferung",
    "starlink.step3": "Montage & Konfiguration",
    "starlink.step4": "Übergabe & Support",

    "why.eyebrow": "Warum uns Deutsche auf Mallorca wählen",
    "why.title": "Premium statt Standardlösungen",
    "why.r1.title": "Deutsche Zuverlässigkeit",
    "why.r1.desc": "Termine, die halten. Lösungen, die bleiben.",
    "why.r2.title": "Moderne KI- & Tech-Lösungen",
    "why.r2.desc": "Wir kombinieren bewährte Technik mit aktueller KI.",
    "why.r3.title": "Persönlicher Ansprechpartner",
    "why.r3.desc": "Ein Gesicht, ein Name, eine WhatsApp-Nummer.",
    "why.r4.title": "Vor-Ort-Service auf Mallorca",
    "why.r4.desc": "Von Palma bis Pollença – wir kommen zu Ihnen.",
    "why.r5.title": "Schnelle Hilfe via WhatsApp",
    "why.r5.desc": "Kurze Wege, klare Antworten, deutscher Support.",
    "why.r6.title": "Premium statt Standard",
    "why.r6.desc": "Wir liefern Lösungen, die sich anfühlen wie Apple.",

    "customers.eyebrow": "Für wen wir arbeiten",
    "customers.title": "Maßgeschneidert für Ihr Lebens- oder Geschäftsmodell",
    "customers.villa": "Villa-Eigentümer",
    "customers.airbnb": "Airbnb Gastgeber",
    "customers.restaurant": "Restaurants",
    "customers.realestate": "Immobilien­agenturen",
    "customers.nomad": "Digital Nomads",
    "customers.streamer": "Streamer & Creator",
    "customers.entrepreneur": "Unternehmer",

    "process.eyebrow": "So einfach geht's",
    "process.title": "In 4 Schritten zur Lösung",
    "process.s1.title": "Anfrage senden",
    "process.s1.desc": "Per Formular oder WhatsApp – wir melden uns innerhalb 24h.",
    "process.s2.title": "Kostenloses Gespräch",
    "process.s2.desc": "Wir analysieren Ihren Bedarf in einem persönlichen Call.",
    "process.s3.title": "Individuelle Lösung",
    "process.s3.desc": "Sie erhalten ein transparentes Angebot ohne versteckte Kosten.",
    "process.s4.title": "Installation & Betreuung",
    "process.s4.desc": "Wir installieren, schulen und bleiben Ihr Ansprechpartner.",

    "testimonials.eyebrow": "Stimmen",
    "testimonials.title": "Was Kunden über uns sagen",
    "testimonials.t1.text":
      "Endlich Starlink in unserer Finca bei Artà – seit Wochen läuft alles stabil, sogar 4K-Streaming.",
    "testimonials.t1.name": "Markus & Anja",
    "testimonials.t1.role": "Villa-Eigentümer, Artà",
    "testimonials.t2.text":
      "Unsere Airbnb-Gäste loben das WLAN. Buchungen sind seitdem messbar hochgegangen.",
    "testimonials.t2.name": "Stefan Hoffmann",
    "testimonials.t2.role": "Airbnb Host, Pollença",
    "testimonials.t3.text":
      "Smart Home, Kameras, Alarm – alles in einer App. Service ist absolut Premium.",
    "testimonials.t3.name": "Familie Becker",
    "testimonials.t3.role": "Privatkunde, Son Vida",
    "testimonials.t4.text":
      "Mobiles Streaming-Setup mit Starlink. Mein Twitch-Kanal läuft endlich ohne Lags.",
    "testimonials.t4.name": "Leo K.",
    "testimonials.t4.role": "Streamer, Palma",

    "contact.eyebrow": "Kontakt",
    "contact.title": "Technische Hilfe auf Mallorca? Wir kümmern uns darum.",
    "contact.subtitle":
      "Schreiben Sie uns – wir antworten in der Regel innerhalb von 24 Stunden auf Deutsch.",
    "contact.name": "Ihr Name",
    "contact.email": "E-Mail Adresse",
    "contact.phone": "Telefon (optional)",
    "contact.service": "Gewünschte Leistung",
    "contact.service.placeholder": "Bitte wählen",
    "contact.message": "Ihre Nachricht",
    "contact.submit": "Anfrage senden",
    "contact.success": "Vielen Dank! Wir melden uns in Kürze bei Ihnen.",
    "contact.whatsapp": "Direkt auf WhatsApp schreiben",
    "contact.location": "Mallorca · Inselweiter Service",

    "footer.tagline": "Premium Tech Service für Deutsche auf Mallorca.",
    "footer.services": "Leistungen",
    "footer.company": "Unternehmen",
    "footer.legal": "Rechtliches",
    "footer.impressum": "Impressum",
    "footer.privacy": "Datenschutz",
    "footer.copyright": "© 2025 Mallorca Digital & Tech Services",

    "blog.eyebrow": "Magazin",
    "blog.title": "Wissen für die digitale Insel",
    "blog.subtitle":
      "Praxis-Tipps zu Starlink, WLAN, Smart Home und Tech-Setup auf Mallorca – geschrieben aus echter Vor-Ort-Erfahrung.",
    "blog.read": "Beitrag lesen",
    "blog.minutes": "Min. Lesezeit",
    "blog.back": "Zurück zum Magazin",
    "blog.empty": "Bald erscheinen hier neue Beiträge.",
    "blog.cta.title": "Bereit für Ihren nächsten Schritt?",
    "blog.cta.subtitle": "Kostenlose Erst-Beratung – auf Deutsch, persönlich, ohne Verpflichtung.",
    "blog.related": "Weitere Beiträge",

    "admin.blog.title": "Magazin verwalten",
    "admin.blog.subtitle": "Alle Blog-Beiträge ansehen, anlegen, veröffentlichen.",
    "admin.blog.tab.leads": "Leads",
    "admin.blog.tab.blog": "Magazin",
    "admin.blog.new": "Neuer Beitrag",
    "admin.blog.slug": "Slug",
    "admin.blog.created": "Erstellt",
    "admin.blog.tags": "Tags",
    "admin.blog.publish": "Veröffentlicht",
    "admin.blog.actions": "Aktionen",
    "admin.blog.delete": "Löschen",
    "admin.login.title": "Admin Login",
    "admin.login.subtitle": "Nur für interne Teammitglieder",
    "admin.login.email": "E-Mail",
    "admin.login.password": "Passwort",
    "admin.login.submit": "Einloggen",
    "admin.leads.title": "Leads & Anfragen",
    "admin.leads.subtitle": "Alle eingehenden Kontaktanfragen",
    "admin.leads.logout": "Abmelden",
    "admin.leads.empty": "Noch keine Anfragen.",
    "admin.leads.name": "Name",
    "admin.leads.email": "E-Mail",
    "admin.leads.phone": "Telefon",
    "admin.leads.service": "Leistung",
    "admin.leads.message": "Nachricht",
    "admin.leads.created": "Eingegangen",
    "admin.leads.status": "Status",
  },

  en: {
    "nav.services": "Services",
    "nav.starlink": "Starlink",
    "nav.why": "Why us",
    "nav.process": "Process",
    "nav.blog": "Magazine",
    "nav.contact": "Contact",
    "nav.cta": "Request consultation",

    "hero.eyebrow": "Premium Tech Concierge · Mallorca",
    "hero.title": "Digital & technical solutions for Germans on Mallorca",
    "hero.subtitle":
      "Starlink internet, premium WiFi, smart home, websites, AI automations & tech support — all in one place.",
    "hero.cta1": "Free consultation",
    "hero.cta2": "WhatsApp",
    "hero.scroll": "Discover more",
    "hero.trust1": "German-speaking support",
    "hero.trust2": "Starlink certified",
    "hero.trust3": "Mesh specialist",

    "trust.title": "German precision, delivered on the island",
    "trust.b1": "German service",
    "trust.b2": "On-site Mallorca",
    "trust.b3": "Premium support",
    "trust.b4": "Starlink specialist",
    "trust.kpi1.value": "<24h",
    "trust.kpi1.label": "Response time",
    "trust.kpi2.value": "400 Mbps",
    "trust.kpi2.label": "Starlink speed",
    "trust.kpi3.value": "100%",
    "trust.kpi3.label": "German speaking",

    "services.eyebrow": "Services",
    "services.title": "One address for everything tech",
    "services.subtitle":
      "From the first WiFi router to a complete smart villa — we plan, install, and maintain.",
    "services.starlink.title": "Starlink Internet Mallorca",
    "services.starlink.desc":
      "High-speed internet up to 400 Mbps for villas, fincas and remote locations. Fast install, low latency, ideal for remote work & streaming.",
    "services.wifi.title": "Premium WiFi & Mesh",
    "services.wifi.desc":
      "Stable WiFi in every corner of your villa. Mesh systems, business WiFi and optimization of existing networks.",
    "services.smart.title": "Smart home & security",
    "services.smart.desc":
      "Cameras, smart locks, alarms and remote monitoring. Control your villa from your phone.",
    "services.digital.title": "Digital services",
    "services.digital.desc":
      "Websites, booking systems, SEO, Google Maps optimization, AI chatbots and automations.",
    "services.creator.title": "Creator & streaming setups",
    "services.creator.desc":
      "IRL streaming, mobile setups, Starlink for creators, encoders, audio & video optimization.",
    "services.support.title": "Tech support & concierge",
    "services.support.desc":
      "German-speaking support, fast help via WhatsApp, remote and on-site service across Mallorca.",

    "starlink.eyebrow": "Starlink specialist",
    "starlink.title": "Starlink internet on Mallorca",
    "starlink.p1":
      "Many places on Mallorca still suffer from poor internet. We experienced it ourselves and searched for a solution that actually works.",
    "starlink.p2":
      "With Starlink we deliver stable, fast connections to fincas, villas and remote locations. We handle consulting, installation, configuration and long-term support.",
    "starlink.b1": "Internet even in remote areas",
    "starlink.b2": "Up to 400 Mbps download",
    "starlink.b3": "Low latency for remote work",
    "starlink.b4": "Streaming capable connection",
    "starlink.b5": "Fast installation",
    "starlink.cta": "Request Starlink consultation",
    "starlink.step1": "Site analysis",
    "starlink.step2": "Hardware delivery",
    "starlink.step3": "Mount & configure",
    "starlink.step4": "Handover & support",

    "why.eyebrow": "Why Germans on Mallorca choose us",
    "why.title": "Premium instead of standard",
    "why.r1.title": "German reliability",
    "why.r1.desc": "Appointments we keep. Solutions that last.",
    "why.r2.title": "Modern AI & tech",
    "why.r2.desc": "Proven tech, combined with current AI.",
    "why.r3.title": "Personal contact",
    "why.r3.desc": "One face, one name, one WhatsApp number.",
    "why.r4.title": "On-site on Mallorca",
    "why.r4.desc": "From Palma to Pollença — we come to you.",
    "why.r5.title": "Fast help via WhatsApp",
    "why.r5.desc": "Short paths, clear answers, German support.",
    "why.r6.title": "Premium not standard",
    "why.r6.desc": "Solutions that feel like Apple.",

    "customers.eyebrow": "Who we work with",
    "customers.title": "Tailored to your lifestyle or business",
    "customers.villa": "Villa owners",
    "customers.airbnb": "Airbnb hosts",
    "customers.restaurant": "Restaurants",
    "customers.realestate": "Real estate agencies",
    "customers.nomad": "Digital nomads",
    "customers.streamer": "Streamers & creators",
    "customers.entrepreneur": "Entrepreneurs",

    "process.eyebrow": "It's that simple",
    "process.title": "Your solution in 4 steps",
    "process.s1.title": "Send request",
    "process.s1.desc": "Via form or WhatsApp — we reply within 24h.",
    "process.s2.title": "Free consultation",
    "process.s2.desc": "We analyse your needs in a personal call.",
    "process.s3.title": "Tailored solution",
    "process.s3.desc": "A transparent quote without hidden costs.",
    "process.s4.title": "Install & support",
    "process.s4.desc": "We install, train and stay your contact.",

    "testimonials.eyebrow": "Voices",
    "testimonials.title": "What clients say",
    "testimonials.t1.text":
      "Finally Starlink in our finca near Artà — running stable for weeks, even 4K streaming.",
    "testimonials.t1.name": "Markus & Anja",
    "testimonials.t1.role": "Villa owners, Artà",
    "testimonials.t2.text":
      "Our Airbnb guests love the WiFi. Bookings went measurably up.",
    "testimonials.t2.name": "Stefan Hoffmann",
    "testimonials.t2.role": "Airbnb host, Pollença",
    "testimonials.t3.text":
      "Smart home, cameras, alarm — all in one app. Truly premium service.",
    "testimonials.t3.name": "The Becker family",
    "testimonials.t3.role": "Private client, Son Vida",
    "testimonials.t4.text":
      "Mobile streaming setup with Starlink. My Twitch channel finally runs without lag.",
    "testimonials.t4.name": "Leo K.",
    "testimonials.t4.role": "Streamer, Palma",

    "contact.eyebrow": "Contact",
    "contact.title": "Need tech help on Mallorca? We've got it.",
    "contact.subtitle":
      "Write to us — we usually reply within 24 hours in German or English.",
    "contact.name": "Your name",
    "contact.email": "Email",
    "contact.phone": "Phone (optional)",
    "contact.service": "Service",
    "contact.service.placeholder": "Please choose",
    "contact.message": "Your message",
    "contact.submit": "Send request",
    "contact.success": "Thank you! We'll get back to you shortly.",
    "contact.whatsapp": "Message on WhatsApp",
    "contact.location": "Mallorca · Island-wide service",

    "footer.tagline": "Premium tech service for Germans on Mallorca.",
    "footer.services": "Services",
    "footer.company": "Company",
    "footer.legal": "Legal",
    "footer.impressum": "Imprint",
    "footer.privacy": "Privacy",
    "footer.copyright": "© 2025 Mallorca Digital & Tech Services",

    "blog.eyebrow": "Magazine",
    "blog.title": "Knowledge for the digital island",
    "blog.subtitle":
      "Hands-on tips on Starlink, WiFi, smart home and tech setups on Mallorca — written from real on-site experience.",
    "blog.read": "Read article",
    "blog.minutes": "min read",
    "blog.back": "Back to magazine",
    "blog.empty": "New posts coming soon.",
    "blog.cta.title": "Ready for your next step?",
    "blog.cta.subtitle": "Free first consultation — in German or English, no strings attached.",
    "blog.related": "More articles",

    "admin.blog.title": "Manage magazine",
    "admin.blog.subtitle": "View, create and publish blog posts.",
    "admin.blog.tab.leads": "Leads",
    "admin.blog.tab.blog": "Magazine",
    "admin.blog.new": "New post",
    "admin.blog.slug": "Slug",
    "admin.blog.created": "Created",
    "admin.blog.tags": "Tags",
    "admin.blog.publish": "Published",
    "admin.blog.actions": "Actions",
    "admin.blog.delete": "Delete",
    "admin.login.title": "Admin login",
    "admin.login.subtitle": "Internal team members only",
    "admin.login.email": "Email",
    "admin.login.password": "Password",
    "admin.login.submit": "Sign in",
    "admin.leads.title": "Leads & requests",
    "admin.leads.subtitle": "All incoming contact requests",
    "admin.leads.logout": "Sign out",
    "admin.leads.empty": "No requests yet.",
    "admin.leads.name": "Name",
    "admin.leads.email": "Email",
    "admin.leads.phone": "Phone",
    "admin.leads.service": "Service",
    "admin.leads.message": "Message",
    "admin.leads.created": "Received",
    "admin.leads.status": "Status",
  },

  es: {
    "nav.services": "Servicios",
    "nav.starlink": "Starlink",
    "nav.why": "Por qué nosotros",
    "nav.process": "Proceso",
    "nav.blog": "Magazine",
    "nav.contact": "Contacto",
    "nav.cta": "Solicitar asesoría",

    "hero.eyebrow": "Concierge Tech Premium · Mallorca",
    "hero.title": "Soluciones digitales y técnicas para alemanes en Mallorca",
    "hero.subtitle":
      "Internet Starlink, WiFi premium, smart home, webs, automatización con IA y soporte técnico — todo en un solo sitio.",
    "hero.cta1": "Consulta gratuita",
    "hero.cta2": "WhatsApp",
    "hero.scroll": "Descubrir más",
    "hero.trust1": "Atención en alemán",
    "hero.trust2": "Certificado Starlink",
    "hero.trust3": "Especialista mesh",

    "trust.title": "Precisión alemana, entregada en la isla",
    "trust.b1": "Servicio en alemán",
    "trust.b2": "Servicio in situ",
    "trust.b3": "Soporte premium",
    "trust.b4": "Especialista Starlink",
    "trust.kpi1.value": "<24h",
    "trust.kpi1.label": "Tiempo de respuesta",
    "trust.kpi2.value": "400 Mbps",
    "trust.kpi2.label": "Velocidad Starlink",
    "trust.kpi3.value": "100%",
    "trust.kpi3.label": "En alemán",

    "services.eyebrow": "Servicios",
    "services.title": "Una sola dirección para toda la tecnología",
    "services.subtitle":
      "Desde el primer router WiFi hasta una smart villa completa — planificamos, instalamos y mantenemos.",
    "services.starlink.title": "Starlink Internet Mallorca",
    "services.starlink.desc":
      "Internet de alta velocidad hasta 400 Mbps para villas, fincas y zonas remotas. Instalación rápida, baja latencia, ideal para teletrabajo y streaming.",
    "services.wifi.title": "WiFi Premium & Mesh",
    "services.wifi.desc":
      "WiFi estable en cada rincón de su villa. Sistemas mesh, WiFi para negocios y optimización de redes existentes.",
    "services.smart.title": "Smart home & seguridad",
    "services.smart.desc":
      "Cámaras, cerraduras inteligentes, alarmas y monitorización remota. Controle su villa desde el móvil.",
    "services.digital.title": "Servicios digitales",
    "services.digital.desc":
      "Webs, sistemas de reservas, SEO, optimización Google Maps, chatbots IA y automatización.",
    "services.creator.title": "Creator & streaming",
    "services.creator.desc":
      "IRL streaming, equipos móviles, Starlink para creators, encoders, optimización de audio y vídeo.",
    "services.support.title": "Soporte técnico & concierge",
    "services.support.desc":
      "Soporte en alemán, ayuda rápida por WhatsApp, servicio remoto e in situ en toda Mallorca.",

    "starlink.eyebrow": "Especialista Starlink",
    "starlink.title": "Internet Starlink en Mallorca",
    "starlink.p1":
      "Muchos lugares de Mallorca aún sufren mala conectividad. Lo vivimos en primera persona y buscamos una solución que realmente funcione.",
    "starlink.p2":
      "Con Starlink llevamos conexiones estables y rápidas a fincas, villas y zonas remotas. Nos ocupamos del asesoramiento, instalación, configuración y soporte continuo.",
    "starlink.b1": "Internet incluso en zonas remotas",
    "starlink.b2": "Hasta 400 Mbps de descarga",
    "starlink.b3": "Baja latencia para teletrabajo",
    "starlink.b4": "Conexión apta para streaming",
    "starlink.b5": "Instalación rápida",
    "starlink.cta": "Solicitar asesoría Starlink",
    "starlink.step1": "Análisis del lugar",
    "starlink.step2": "Entrega de hardware",
    "starlink.step3": "Montaje y configuración",
    "starlink.step4": "Entrega y soporte",

    "why.eyebrow": "Por qué nos eligen",
    "why.title": "Premium en lugar de estándar",
    "why.r1.title": "Fiabilidad alemana",
    "why.r1.desc": "Citas que se cumplen. Soluciones que perduran.",
    "why.r2.title": "IA y tecnología moderna",
    "why.r2.desc": "Tecnología probada con IA actual.",
    "why.r3.title": "Contacto personal",
    "why.r3.desc": "Una cara, un nombre, un número de WhatsApp.",
    "why.r4.title": "Servicio in situ Mallorca",
    "why.r4.desc": "De Palma a Pollença — vamos a usted.",
    "why.r5.title": "Ayuda rápida por WhatsApp",
    "why.r5.desc": "Caminos cortos, respuestas claras.",
    "why.r6.title": "Premium, no estándar",
    "why.r6.desc": "Soluciones con sensación Apple.",

    "customers.eyebrow": "Con quién trabajamos",
    "customers.title": "Hecho a medida para su vida o negocio",
    "customers.villa": "Propietarios de villas",
    "customers.airbnb": "Anfitriones Airbnb",
    "customers.restaurant": "Restaurantes",
    "customers.realestate": "Agencias inmobiliarias",
    "customers.nomad": "Nómadas digitales",
    "customers.streamer": "Streamers y creadores",
    "customers.entrepreneur": "Emprendedores",

    "process.eyebrow": "Así de sencillo",
    "process.title": "Su solución en 4 pasos",
    "process.s1.title": "Envíe su petición",
    "process.s1.desc": "Por formulario o WhatsApp — respondemos en 24h.",
    "process.s2.title": "Llamada gratuita",
    "process.s2.desc": "Analizamos su necesidad en una llamada personal.",
    "process.s3.title": "Solución a medida",
    "process.s3.desc": "Presupuesto transparente, sin costes ocultos.",
    "process.s4.title": "Instalación y soporte",
    "process.s4.desc": "Instalamos, formamos y seguimos a su lado.",

    "testimonials.eyebrow": "Voces",
    "testimonials.title": "Lo que dicen los clientes",
    "testimonials.t1.text":
      "Por fin Starlink en nuestra finca en Artà — estable durante semanas, incluso streaming 4K.",
    "testimonials.t1.name": "Markus & Anja",
    "testimonials.t1.role": "Propietarios de villa, Artà",
    "testimonials.t2.text":
      "Nuestros huéspedes Airbnb adoran el WiFi. Las reservas han subido claramente.",
    "testimonials.t2.name": "Stefan Hoffmann",
    "testimonials.t2.role": "Anfitrión Airbnb, Pollença",
    "testimonials.t3.text":
      "Smart home, cámaras, alarma — todo en una app. Servicio realmente premium.",
    "testimonials.t3.name": "Familia Becker",
    "testimonials.t3.role": "Cliente privado, Son Vida",
    "testimonials.t4.text":
      "Setup de streaming móvil con Starlink. Mi canal de Twitch por fin sin lag.",
    "testimonials.t4.name": "Leo K.",
    "testimonials.t4.role": "Streamer, Palma",

    "contact.eyebrow": "Contacto",
    "contact.title": "¿Necesita ayuda técnica en Mallorca? Nos ocupamos.",
    "contact.subtitle":
      "Escríbanos — normalmente respondemos en 24 horas en alemán o inglés.",
    "contact.name": "Su nombre",
    "contact.email": "Email",
    "contact.phone": "Teléfono (opcional)",
    "contact.service": "Servicio",
    "contact.service.placeholder": "Elija una opción",
    "contact.message": "Su mensaje",
    "contact.submit": "Enviar solicitud",
    "contact.success": "¡Gracias! Le contactaremos en breve.",
    "contact.whatsapp": "Escribir por WhatsApp",
    "contact.location": "Mallorca · Servicio en toda la isla",

    "footer.tagline": "Servicio técnico premium para alemanes en Mallorca.",
    "footer.services": "Servicios",
    "footer.company": "Empresa",
    "footer.legal": "Legal",
    "footer.impressum": "Aviso legal",
    "footer.privacy": "Privacidad",
    "footer.copyright": "© 2025 Mallorca Digital & Tech Services",

    "blog.eyebrow": "Magazine",
    "blog.title": "Conocimiento para la isla digital",
    "blog.subtitle":
      "Consejos prácticos sobre Starlink, WiFi, smart home y setups técnicos en Mallorca — escritos desde la experiencia real in situ.",
    "blog.read": "Leer artículo",
    "blog.minutes": "min de lectura",
    "blog.back": "Volver al magazine",
    "blog.empty": "Pronto llegarán nuevos artículos.",
    "blog.cta.title": "¿Listo para el siguiente paso?",
    "blog.cta.subtitle": "Primera consulta gratuita — en alemán o inglés, sin compromiso.",
    "blog.related": "Más artículos",

    "admin.blog.title": "Gestionar magazine",
    "admin.blog.subtitle": "Ver, crear y publicar entradas.",
    "admin.blog.tab.leads": "Leads",
    "admin.blog.tab.blog": "Magazine",
    "admin.blog.new": "Nueva entrada",
    "admin.blog.slug": "Slug",
    "admin.blog.created": "Creada",
    "admin.blog.tags": "Tags",
    "admin.blog.publish": "Publicada",
    "admin.blog.actions": "Acciones",
    "admin.blog.delete": "Eliminar",
    "admin.login.title": "Login admin",
    "admin.login.subtitle": "Solo equipo interno",
    "admin.login.email": "Email",
    "admin.login.password": "Contraseña",
    "admin.login.submit": "Entrar",
    "admin.leads.title": "Leads y solicitudes",
    "admin.leads.subtitle": "Todas las solicitudes entrantes",
    "admin.leads.logout": "Salir",
    "admin.leads.empty": "Aún no hay solicitudes.",
    "admin.leads.name": "Nombre",
    "admin.leads.email": "Email",
    "admin.leads.phone": "Teléfono",
    "admin.leads.service": "Servicio",
    "admin.leads.message": "Mensaje",
    "admin.leads.created": "Recibido",
    "admin.leads.status": "Estado",
  },
};
